import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Input, InputNumber, Spin, Popconfirm } from "antd";
import { v4 as uuidv4 } from "uuid";
import { DeleteOutlined } from "@ant-design/icons";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import {
  createAccommodation,
  getAccommodation,
  updateAccommodation,
} from "../../services/AccommodationService";
import { deleteFile, getOneFile } from "../../services/FileService";
import "./NewAccommodationPage.scss";
import { Image } from "antd";
import { File } from "../../models/File";
import BasicInformation from "./BasicInformation";
import UploadImage from "./UploadImage";
import { CreateRoomType, UpdateRoomType } from "../../models/RoomType";
import { Toast } from "primereact/toast";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";

const NewAccommodationPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { setBreadcrumb } = useApplicationContext();
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [allRoomType, setAllRoomType] = useState<any[]>([]);
  const [allTags, setAllTags] = useState<string[]>([]);
  const [validationInputRoomType, setValidationInputRoomType] =
    useState<boolean>(true);
  const [checkValidation, setCheckValidation] = useState(false);

  ///// PATH FOR IMAGES
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";
  const toast = useRef<any>(null);
  ///// END PATH FOR IMAGES

  ///// FUNCTION ADD NEW ROOM TYPE

  const addNewRoomType = () => {
    setCheckValidation(false);
    setAllRoomType([
      ...allRoomType,
      {
        id: uuidv4(),
        name: "",
        priceType: null,
        price: {},
        capacity: "",
        roomsTotalNumber: "",
        note: "",
        photos: [],
      },
    ]);
  };

  //// CREATE FORMS

  const [form] = Form.useForm();

  //// ALL IMAGE UPLOAD FUNC

  const allImageFunc = (image: File, id: string) => {
    let copyArrRoomType = [...allRoomType];
    let findOne = copyArrRoomType.find((room) => room.id === id);
    findOne.photos = [...findOne.photos, image];

    setAllRoomType(copyArrRoomType);
  };

  ////// DELETE ONE IMAGE

  const deletePhoto = async (deletedImage: File, id: string) => {
    await deleteFile(deletedImage.id).then(() => {
      toast?.current?.show({
        severity: "success",
        detail: "Slika je izbrisana!",
        life: 3000,
      });
    });

    let copyArrRoomType = [...allRoomType];
    let findOne = copyArrRoomType.find((room) => room.id === id);
    findOne.photos = findOne.photos.filter(
      (imageId: File) => imageId.id !== deletedImage.id
    );

    setAllRoomType(copyArrRoomType);
  };

  /// END DELETE FUNC

  //// GET ALL TAGS FUNC

  const getAllTagsFunc = (tags: string[]) => {
    setAllTags(tags);
  };

  /// END GET ALL TAGS FUNC

  ///// FUNKCIJE ZA CHANGE INPUTA

  const changeRoomTypeInAcc = (
    id: string,
    inputName: string,
    value: string | number
  ) => {
    let copyArrRoomType = [...allRoomType];
    let changeCard = copyArrRoomType.find(
      (roomType: CreateRoomType) => roomType.id === id
    );

    changeCard[inputName] = value;

    setAllRoomType(copyArrRoomType);
  };

  const changeCapacity = (
    id: string,
    inputName: string,
    value: string | number
  ) => {
    let copyArrRoomType = [...allRoomType];
    let changeCard = copyArrRoomType.find(
      (roomType: CreateRoomType) => roomType.id === id
    );

    changeCard[inputName] = value;

    let copyPrice = { ...changeCard.price };

    if (
      Number(changeCard.capacity) <
      Object.keys(changeCard.price).length + 1
    ) {
      changeCard.price = {};
      changeCard.price = { priceForRoom: copyPrice.priceForRoom };
      //handleClearInput();
    }

    setAllRoomType(copyArrRoomType);
  };

  const changePriceForRoomType = (
    id: string,
    inputName: string,
    value: string | number
  ) => {
    let copyArrRoomType = [...allRoomType];
    let changeCard = copyArrRoomType.find(
      (roomType: CreateRoomType) => roomType.id === id
    );

    changeCard.price = { ...changeCard.price, [inputName]: value };

    setAllRoomType(copyArrRoomType);
  };

  //// END FUNKCIJE ZA CHANGE INPUTA

  //// END UPLOAD PHOTO FUNC

  useEffect(() => {
    if (id !== undefined) {
      setActiveSpinner(true);
      getAccommodation(id).then((response) => {
        const data = response.data.result;

        setAllRoomType(data?.roomType); /// set all roomType
        if (data.tags !== null) setAllTags(data.tags); // set all tags

        form.setFieldsValue(data); //// set full data objects
        setActiveSpinner(false);
        let newBreadcrumb: string[] = ["Smeštaj"];
        newBreadcrumb.push(data.name as string);
        setBreadcrumb(newBreadcrumb);
      });
    } else {
      form.resetFields();
      setAllRoomType([]);
      setAllTags([]);
      setBreadcrumb(["Smeštaj", "Novi smeštaj"]);
    }
  }, [id]);

  const saveNewAccommodation = () => {
    setCheckValidation(true);
    form.validateFields({ validateOnly: true }).then(
      () => {
        setActiveSpinner(true);

        let oneAccommodation = form.getFieldsValue();

        let roomTypeWithoutId = [...allRoomType].map((element) => {
          if (element.createdAt) {
            return element;
          } else {
            const { id, ...rest } = element;
            return rest;
          }
        });
        oneAccommodation.roomType = roomTypeWithoutId;
        oneAccommodation.tags = allTags;

        /// END ADD IMAGE ON FORM

        if (id === undefined) {
          let totalRoomType = 0;
          allRoomType.forEach(function (roomType) {
            totalRoomType += parseInt(roomType.roomsTotalNumber);
          });

          if (allRoomType.length === 0) {
            setActiveSpinner(false);
            toast?.current?.show({
              severity: "error",
              detail: "Pogresan unos, morate uneti bar jedan tip sobe!",
              life: 3000,
            });
          } else if (
            totalRoomType !== parseInt(oneAccommodation.totalNumberOfRooms)
          ) {
            setActiveSpinner(false);
            toast?.current?.show({
              severity: "error",
              detail:
                "Pogresan unos, ne poklapa se ukupan broj soba i uneti broj tipova soba!",
              life: 3000,
            });
          } else {
            createAccommodation(oneAccommodation)
              .then(() => {
                toast?.current?.show({
                  severity: "success",
                  detail: "Uspešno kreiran smeštaj",
                  life: 3000,
                });
              })
              .finally(() => {
                setActiveSpinner(false);
                navigate("/accommodation-list", { replace: true });
              })
              .catch((err) => console.log(err));
          }
        } else {
          let totalRoomType = 0;
          allRoomType.forEach(function (roomType) {
            totalRoomType += parseInt(roomType.roomsTotalNumber);
          });

          if (allRoomType.length === 0) {
            setActiveSpinner(false);
            toast?.current?.show({
              severity: "error",
              detail: "Pogresan unos, morate uneti bar jedan tip sobe!",
              life: 3000,
            });
          } else if (
            totalRoomType !== parseInt(oneAccommodation.totalNumberOfRooms)
          ) {
            setActiveSpinner(false);
            toast?.current?.show({
              severity: "error",
              detail:
                "Pogresan unos, ne poklapa se ukupan broj soba i uneti broj tipova soba!",
              life: 3000,
            });
          } else {
            updateAccommodation(id, oneAccommodation)
              .then(() => {
                toast?.current?.show({
                  severity: "success",
                  detail: "Uspešno ažurirani podaci o smeštaju",
                  life: 3000,
                });
              })
              .finally(() => {
                setActiveSpinner(false);
                navigate("/accommodation-list", { replace: true });
              })
              .catch((err) => console.log(err));
          }
        }
      },
      () => {
        console.log("");
      }
    );
  };

  useEffect(() => {
    if (checkValidation) {
      checkInput("", "");
      messageInputs("", "");
    }
  }, [checkValidation]);

  const checkInput = (type: string, value: string | number) => {
    if (checkValidation) {
      if (value === "" || value === undefined) {
        if (type === "priceForRoom") {
          return "ant-input-number-status-error";
        } else {
          return "input-label ant-input-status-error";
        }
      }
    }

    return "input-label";
  };

  ///// validation all inputs custom logic
  useEffect(() => {
    const requiredFields = ["name", "roomsTotalNumber", "capacity", "price"];

    const isAllFieldsValid = allRoomType.every((roomType: any) =>
      requiredFields.every((field) =>
        field === "price"
          ? roomType[field]?.priceForRoom !== undefined &&
            roomType[field]?.priceForRoom !== ""
          : roomType[field] !== undefined && roomType[field] !== ""
      )
    );

    setValidationInputRoomType(isAllFieldsValid);
  }, [allRoomType]);
  /// end validation all inputs custom logic

  const messageInputs = (value: string | number, message: string) => {
    if (checkValidation) {
      if (value === "" || value === undefined) {
        return message;
      }
    }
    return "";
  };

  const deleteOneRoomType = (roomType: UpdateRoomType) => {
    const copyArrRoomType = [...allRoomType];
    let newAllRT = copyArrRoomType.filter(
      (RT: UpdateRoomType) => RT.id !== roomType.id
    );

    setAllRoomType(newAllRT);
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <div className="new-accommodation">
        <Spin spinning={activeSpinner}>
          <Form
            form={form}
            name="new-accommodation-form"
            layout="vertical"
            autoComplete="off"
          >
            <div className="new-accommodation-form-body">
              <BasicInformation
                getAllTagsFunc={getAllTagsFunc}
                allTagsValues={allTags} // == zavrsiti povlacenje tagova
                child={
                  <div
                    className="from-container"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "3px",
                    }}
                  >
                    <CustomButton
                      danger={true}
                      type={"primary"}
                      function={addNewRoomType}
                      text={"Dodaj tip smeštaja"}
                    />
                  </div>
                }
              />
            </div>
            <div className="form-container all-card-rt">
              {allRoomType.map((roomType: UpdateRoomType, index: number) => {
                let capacity = Number(roomType.capacity);
                return (
                  <div className="card-roomType" key={index}>
                    <div className="first-column-rt">
                      <div className="first-row-first-column">
                        <Form.Item name={`name${index}`} label="Tip sobe:">
                          <Input
                            className={checkInput("name", roomType?.name)}
                            placeholder="Unesite tip sobe"
                            name={`name${index}`}
                            onChange={(e) => {
                              changeRoomTypeInAcc(
                                roomType.id,
                                "name",
                                e.target.value
                              );
                            }}
                            defaultValue={roomType?.name}
                          />
                          <span style={{ color: "red" }}>
                            {messageInputs(
                              roomType?.name,
                              "Potrebno je uneti tip sobe!"
                            )}
                          </span>
                        </Form.Item>
                        <Form.Item
                          name={`roomsTotalNumber${index}`}
                          label="Broj soba:"
                        >
                          <Input
                            type="number"
                            className={checkInput(
                              "roomsTotalNumber",
                              roomType?.roomsTotalNumber
                            )}
                            placeholder="Unesite broj soba"
                            name={`roomsTotalNumber${index}`}
                            onChange={(e) => {
                              changeRoomTypeInAcc(
                                roomType.id,
                                "roomsTotalNumber",
                                e.target.value
                              );
                            }}
                            defaultValue={roomType?.roomsTotalNumber}
                            min={1}
                          />
                          <span style={{ color: "red" }}>
                            {messageInputs(
                              roomType?.roomsTotalNumber,
                              "Potrebno je uneti broj soba!"
                            )}
                          </span>
                        </Form.Item>

                        <Form.Item name={`capacity${index}`} label="Kapacitet:">
                          <Input
                            type="number"
                            className={checkInput(
                              "capacity",
                              roomType?.capacity
                            )}
                            placeholder="Unesite kapacitet sobe"
                            name={`capacity${index}`}
                            onChange={(e) => {
                              changeCapacity(
                                roomType.id,
                                "capacity",
                                Number(e.target.value) > 10
                                  ? "10"
                                  : e.target.value
                              );
                            }}
                            min={1}
                            max={10}
                            defaultValue={roomType?.capacity}
                          />
                          <span style={{ color: "red" }}>
                            {messageInputs(
                              roomType?.capacity,
                              "Potrebno je uneti kapacitet soba!"
                            )}
                          </span>
                        </Form.Item>

                        <Form.Item
                          name={`priceForRoom${index}`}
                          label="Cena sobe:"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            className={checkInput(
                              "priceForRoom",
                              roomType.price.priceForRoom
                            )}
                            defaultValue={roomType?.price?.priceForRoom}
                            placeholder="Unesite cenu kotizacije"
                            name={`priceForRoom${index}`}
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) =>
                              value!.replace(/\$\s?|(,*)/g, "")
                            }
                            onChange={(e) => {
                              changePriceForRoomType(
                                roomType.id,
                                "priceForRoom",
                                e
                              );
                            }}
                          />
                          <span style={{ color: "red" }}>
                            {messageInputs(
                              roomType?.price?.priceForRoom,
                              "Potrebno je uneti cenu soba!"
                            )}
                          </span>
                        </Form.Item>
                      </div>
                      <div className="second-row-first-column-rt">
                        {roomType.createdAt || capacity !== roomType.capacity
                          ? Array.from(Array(capacity).keys())?.map(
                              (i: number) => {
                                return (
                                  <Form.Item
                                    name={`priceForPerson${i}${index}`}
                                    label={`Cena za ${i + 1}. osobu:`}
                                    key={i}
                                  >
                                    <InputNumber
                                      style={{ width: "100%" }}
                                      className="input-label inputGroups deletedInputRt"
                                      defaultValue={
                                        roomType?.price[
                                          `priceFor${i + 1}Person`
                                        ] ?? ""
                                      }
                                      placeholder={`Unesite cenu za ${
                                        i + 1
                                      } sobu:`}
                                      name={`priceFor${i}person${index}`}
                                      formatter={(value) =>
                                        `${parseInt(value)}`.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )
                                      }
                                      parser={(value) =>
                                        value!.replace(/\$\s?|(,*)/g, "")
                                      }
                                      onChange={(e) => {
                                        changePriceForRoomType(
                                          roomType.id,
                                          `priceFor${i + 1}Person`,
                                          e
                                        );
                                      }}
                                      min={0}
                                    />
                                  </Form.Item>
                                );
                              }
                            )
                          : Object.entries(roomType?.price)
                              .filter(([key]) => key !== "priceForRoom")
                              .map(([key, value]: any, i) => {
                                return (
                                  <Form.Item
                                    name={`priceForPerson${key}${index}`}
                                    label={`Cena za ${i + 1}. osobu:`}
                                    key={i}
                                  >
                                    <InputNumber
                                      style={{ width: "100%" }}
                                      className="input-label inputGroups"
                                      defaultValue={value.toString()}
                                      placeholder={`Unesite cenu za ${key} sobu:`}
                                      name={`priceFor${key}person${index}`}
                                      formatter={(value) =>
                                        `${value}`.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )
                                      }
                                      parser={(value) =>
                                        value!.replace(/\$\s?|(,*)/g, "")
                                      }
                                      onChange={(e) => {
                                        changePriceForRoomType(
                                          roomType.id,
                                          `${key}`,
                                          parseInt((e ?? "").toString())
                                        );
                                      }}
                                      // min={"0"}
                                    />
                                  </Form.Item>
                                );
                              })}
                      </div>
                      {/* <div className="third-row-first-column-rt">
                        <Form.Item
                          name={`note${index}`}
                          label="Napomena za sobu:"
                        >
                          <Input
                            className="input-label"
                            placeholder="Unesite napomenu za sobu"
                            name={`note${index}`}
                            onChange={(e) => {
                              changeRoomTypeInAcc(
                                roomType.id,
                                "note",
                                e.target.value
                              );
                            }}
                            defaultValue={roomType?.note}
                          />
                        </Form.Item>
                      </div> */}
                    </div>
                    <div className="second-column-rt">
                      <Form.Item label="Dodaj slike:">
                        <div className="images-for-roomType">
                          <UploadImage
                            type={roomType.id}
                            allImageFunc={allImageFunc}
                            toast={toast}
                          />
                          <Image.PreviewGroup>
                            <div className="all-img-prev">
                              {roomType.photos !== undefined &&
                                roomType?.photos?.map(
                                  (image: any, i: number) => {
                                    let parts = image?.name?.split("-");
                                    let result = {
                                      firstFive: parts?.pop()?.substring(0, 7),
                                      lastFour: image?.name?.slice(-4),
                                    };

                                    return (
                                      <div className="upload-image-div" key={i}>
                                        <div className="image-header-u">
                                          <Image
                                            src={`${storageUrl}${image.id}`}
                                          />
                                          <p>
                                            {`${result.firstFive}... ${result.lastFour}`}
                                          </p>
                                        </div>

                                        <div>
                                          <Popconfirm
                                            title="Brisanje slike?"
                                            description="Da li ste sigurni da želite da izbrišete sliku?"
                                            onConfirm={() => {
                                              deletePhoto(image, roomType.id);
                                            }}
                                            onCancel={() => {}}
                                            okText="Da"
                                            cancelText="Ne"
                                          >
                                            <DeleteOutlined
                                              style={{ cursor: "pointer" }}
                                            />
                                          </Popconfirm>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </Image.PreviewGroup>
                        </div>
                      </Form.Item>
                    </div>

                    <div
                      className="delete-roomType"
                      onClick={() => {
                        deleteOneRoomType(roomType);
                      }}
                    >
                      <DeleteOutlined />
                    </div>
                  </div>
                );
              })}
            </div>
            <Form.Item className="submit-container">
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={"primary"}
                function={() => {
                  saveNewAccommodation();
                }}
                text={id === undefined ? "Sačuvaj smeštaj" : "Ažuriraj smeštaj"}
              />
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </PageLayout>
  );
};

export default NewAccommodationPage;
